import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';

import { cn } from '@shared/utils/helpers';

export function TabsList({ className, ...props }: React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn(
        'inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500',
        className
      )}
      {...props}
    />
  );
}
